import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'
import {NinchatTagsFoundEvent} from '../types/events'
import {extractProperties} from '.'

export const tagsFound: CaseReducer<NinchatState> = (state, action) => {
    const {
        realm_id,
        tag_id,
        ...properties
    } = extractProperties<NinchatTagsFoundEvent>(action.payload)

    if (realm_id && !tag_id) {
        state._tags[realm_id] = properties.tag_children
    }
}
